module.exports = __webpack_public_path__ + "static/images/smoothness/ui-bg_glass_55_fbf9ee_1x400.png";